import { useCallback } from 'react';
import axios from '../../../../../api/myAxios';
import { useTranslation } from 'react-i18next';

export function useChatApi(subdomain) {
  const { t } = useTranslation();

  const sendMessage = useCallback(
    async (message) => {
      try {
        const response = await axios.post('/public/chat', {
          message,
          subdomain,
        });
        return response.data;
      } catch (error) {
        console.error('Error getting AI response:', error);
        throw error;
      }
    },
    [subdomain]
  );

  const sendStreamingMessage = useCallback(
    async (message, onChunk, onComplete, onError) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/public/chat/stream`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message, subdomain }),
          }
        );

        if (!response.ok) {
          throw new Error('Erreur réseau');
        }

        const reader = response.body?.getReader();
        const decoder = new TextDecoder();

        if (reader) {
          let buffer = '';
          let fullText = '';

          while (true) {
            const { done, value } = await reader.read();

            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';

            for (const line of lines) {
              if (line.startsWith('data: ')) {
                try {
                  const data = JSON.parse(line.slice(6));

                  if (data.type === 'chunk') {
                    fullText += data.content;
                    onChunk(fullText);
                  } else if (data.type === 'end') {
                    onComplete(fullText);
                  } else if (data.type === 'error') {
                    onError(data.content);
                  }
                } catch (e) {
                  console.error(t('error.console.errorParsingSse'), e);
                }
              }
            }
          }
        }
      } catch (error) {
        console.error('Erreur streaming:', error);
        onError(t('chatWindow.errorMessage'));
      }
    },
    [subdomain, t]
  );

  return { sendMessage, sendStreamingMessage };
}
